
import Modal from "react-bootstrap/Modal";
import { Box, Button, IconButton, Typography, List, ListItem, ListItemText, Chip, Tooltip } from '@mui/material';
import React, { Component } from "react";
import {Button as Button_R} from "react-bootstrap";
import { sweetStatusAlert } from "../../../components/common/SweetAlert";
import { namespace } from "../../../helper/namespace";
import config from "../../../helper/config";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import { AzureStorageManage } from "../../../helper/azureStorageManage";
import { PaymentService } from "../../../service/manage/payments/payment.service";
import DeleteIcon from '@mui/icons-material/Delete';

export default class ReceiptDocUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            manualReceiptFiles :[],
            selectedPayment:undefined,
            receiptLoading: false
        }
        this.fileInputRef = React.createRef();
    }

    componentDidMount(){
        this.handleSelectedPayment()
    }
    componentDidUpdate(prevProps, prevState){
        if(this.props.payments?.length > 0 && (prevProps.showReceiptDoc !== this.props.showReceiptDoc )){
            this.handleSelectedPayment()
        }
    }
    handleSelectedPayment = () => {
        const paymentFind = this.props.payments.find(payment => payment.id === this.props.showReceiptDoc?.id)
        this.setState({
            selectedPayment:paymentFind
        })
    }      
    handleSelectedFileDownload = async (container_id, blobName) => {
        try {
            await AzureStorageManage.downloadBlob(container_id, blobName)
        } catch (error) {
            sweetStatusAlert(namespace.SUCCESS, `File downloaded successfully!!!`, "success")            
        }
    } 
    handleOpenFile = async (container_id, blobName) => {
        await AzureStorageManage.setInline(container_id, blobName)
        const blobUrl = await AzureStorageManage.generateSASUrl(container_id, blobName)
        window.open(blobUrl, '_blank')
    } 
    
    removeSelectedDoc = (index_) => {
        const manualReceiptModified = this.state.manualReceiptFiles.filter((item, index)=>(index !== index_))
        this.setState({manualReceiptFiles:manualReceiptModified}, ()=>{
            if(this.state.manualReceiptFiles.length === 0){
                this.fileInputRef.current.value = null;
            }
        })
    }
    
    handleDocDelete = async (container_id, blobName, id) => {
        try {
            this.setState({
                receiptLoading:true
            })
            await AzureStorageManage.deleteblob(container_id, blobName)    
            const res = await PaymentService.deletePaymentDoc(id)   
            this.props.setPayments(this.deletePaymentInfo(res.data), this.handleSelectedPayment)
            sweetStatusAlert(namespace.SUCCESS, `File deleted successfully!!!`, "success")
        } catch (error) {
            sweetStatusAlert(namespace.FAILED, `Unable to delete the file`, "error")
        } finally{
            this.setState({
                receiptLoading:false
            })
        }
    }
    

    
    nameCheckForFileUpload = (file) => {
        const isHaveSameName = this.state.manualReceiptFiles.some(file_ => file.name === file_.name)
        if(isHaveSameName){
            sweetStatusAlert(namespace.FAILED, `File names are similar`, "error")
            return true
        }
        return false
    }

    sizeCheckForFileUpload = (file) => {
        if(file.size > config.fileUploadConfigs.maxFileSize){
            sweetStatusAlert(namespace.FAILED, `File cannot be uploaded. Check the size of the file ${file.name}!`, "error")
            return true
        }
        return false
    }

    handleSelectedFiles = (e) => {
        const{name ,files} = e.target
        if(this.sizeCheckForFileUpload(files)){
            return
        }
        if(this.nameCheckForFileUpload(files)){
            return
        }
        this.setState({ manualReceiptFiles:  Array.from(e.target.files) });
    }

    truncateFileName = (fileName, maxLength) => {
        if (fileName?.length > maxLength) {
        return "..." + fileName.substring(fileName.length - maxLength);
        }
        return fileName;
    };

    clearSelectedFiles = () => {
        this.fileInputRef.current.value = null; // Clears the selected files
        this.setState({ manualReceiptFiles: [] }); // Clear state
    };

    
    // Helper function to read file as text
    readFile = (file) => {
        return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            resolve(event.target.result);
        };
        reader.onerror = (error) => {
            reject(error);
        };
        reader.readAsArrayBuffer(file);
        });
    };

    addPaymentInfo = (payment_docs) => {
        const payments = [...this.props.payments]
        const modifiedPayments = payments.map(payment => {
            const modifiedPayment = {...payment}
            if(payment?.id === payment_docs[0].payment_id && modifiedPayment?.doc_details){
                modifiedPayment.doc_details.push(...payment_docs)
            }
            return modifiedPayment
        })
        return modifiedPayments
    }

    
    deletePaymentInfo = (payment_doc) => {
        const payments = [...this.props.payments]
        const modifiedPayments = payments.map(payment => {
            const modifiedPayment = {...payment}
            if(payment?.id === payment_doc.payment_id && modifiedPayment?.doc_details?.length){
                const filteredPaymentReceiptList = modifiedPayment?.doc_details.filter(doc => doc.id !== payment_doc.id)
                modifiedPayment["doc_details"] = filteredPaymentReceiptList
            }
            return modifiedPayment
        })
        return modifiedPayments
    }

    onDocUpload = (blobsDetail) => {
        const obj = {
            doc_details:blobsDetail?.map(detail => ({
                ...detail,
                payment_id:this.props.showReceiptDoc.id
            }))
        }
        PaymentService.addPaymentDoc(JSON.stringify(obj))
        .then((res) => {
            if (res.success) {
                sweetStatusAlert("Success!", res.message.success, "success");
                const payments = res.data.length ? res.data : []
                this.props.setPayments(this.addPaymentInfo(payments), this.handleSelectedPayment) 
            } else {
            sweetStatusAlert("Failed!", res.message, "error");
            }
        })
        .catch((error) => {
            sweetStatusAlert("Failed !", "Unable to add Amount!", "error");
        })
        .finally(() => {
            this.setState(
                {
                    manualReceiptFiles:[],
                    receiptLoading:false
                },
                () => {
                    this.clearSelectedFiles()
                }
            );
        });
    }

    render() {
        return (
            <div>
                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.props.showReceiptDoc}
                    onHide={() => this.props.onToggleReceiptDoc(undefined)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title> <h3>Manual Receipt Handling</h3> </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.receiptLoading ? (
                                <div
                                    className="stu-card-title pt-2 col-md-12"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <i className="fas fa-spinner fa-spin"></i>
                                </div>
                            ) :<div>
                            <div className="col-md-12">
                                
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                {   !!this.state.selectedPayment?.doc_details?.length &&
                                    this.state.selectedPayment?.doc_details?.map((doc, index) => {
                                        return (                                            
                                            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '2px', marginBottom: '10px' }}>
                                                <Chip
                                                    icon={<DownloadIcon />}
                                                    label={this.truncateFileName(doc?.name, 35)}
                                                    variant="outlined"
                                                    onClick={()=>{this.handleSelectedFileDownload(this.props.container_id, doc.blob_id)}}
                                                    onDelete={()=>{this.handleDocDelete(this.props.container_id, doc.blob_id, doc.id)}}
                                                />
                                                <IconButton onClick={()=>{this.handleOpenFile(this.props.container_id, doc.blob_id)}}>
                                                    <VisibilityIcon />
                                                </IconButton>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            </div>

                            <Box className="col-md-12" sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
                                <input
                                    ref={this.fileInputRef}
                                    type="file"
                                    name="manualReceiptFiles"
                                    onChange={this.handleSelectedFiles}
                                    style={{ display: 'none' }}
                                    multiple
                                />
                                    <Button
                                        variant="outlined"
                                        component="label"
                                        sx={{ width: '100%', cursor: 'pointer', mb: 2, 
                                            borderColor: '#B2BEB5', 
                                            color: '#B2BEB5', 
                                            '&:hover': {
                                                borderColor: '#A0A0A0', 
                                                backgroundColor: 'rgba(178, 190, 181, 0.1)', 
                                            }}}
                                    >
                                        Select Files
                                        <input
                                            ref={this.fileInputRef}
                                            type="file"
                                            name="manualReceiptFiles"
                                            onChange={this.handleSelectedFiles}
                                            style={{ display: 'none' }}
                                            multiple
                                        />
                                    </Button>

                                {!!this.state.manualReceiptFiles.length && (
                                <Box sx={{ mt: 2 }}>
                                    <Typography variant="h6">Selected Files:</Typography>
                                    <List dense>
                                    {Array.from(this.state.manualReceiptFiles).map((file, index) => (
                                        <ListItem key={index}>
                                        <ListItemText primary={file.name} />
                                        <Tooltip title= "click to clear selected file" >
                                            <IconButton 
                                                style={{
                                                    color: "#A2A5B5",
                                                    fontSize: "20px",
                                                }}
                                                onClick={() => this.removeSelectedDoc(index)}                            
                                            >
                                                <DeleteIcon fontSize="large"/>
                                            </IconButton>
                                        </Tooltip> 
                                        </ListItem>
                                    ))}
                                    </List>

                                </Box>
                                )}
                                {!!this.state.manualReceiptFiles.length &&  <div className="row justify-content-between">
                                    <Button
                                        variant="outlined"                                        
                                        onClick={this.clearSelectedFiles}
                                        sx={{ mt: 1, color: '#B2BEB5', borderColor: '#B2BEB5',  }}
                                    >
                                        Clear Files
                                    </Button>

                                    <Tooltip title="click to upload">
                                        <Button
                                            variant="outlined"                                        
                                            onClick={()=>{
                                                this.setState(
                                                    { receiptLoading: true },
                                                    () => this.props.onFileUpload(this.onDocUpload, this.state.manualReceiptFiles)
                                                );
                                            }}
                                            sx={{ mt: 1, color: 'primary' }}
                                        >
                                            Upload
                                        </Button>
                                    </Tooltip>

                                </div>}
                            </Box>
                        </div>}
                    </Modal.Body>
                    <Modal.Footer>                   
                        <Button_R
                            id="modal-close-button"
                            style={this.props.closeBtnStyle}
                            onClick={() =>
                                this.props.onToggleReceiptDoc(undefined)
                            }
                        >
                            Close
                        </Button_R>
                </Modal.Footer>
                </Modal>
            </div>
        )
    }
}



